export const tr = {
    'client-id': 'ClientID',
    'full-name': 'Ad ve soyad',
    login: 'Kullanıcı adı',
    products: 'Yönetilen ürünlerin listesi'
};
